import { LOCALE } from '@foxrenderfarm/internals'
import intl from 'react-intl-universal'
import { MainLink, getLocalAppOrigin, withLocale } from '../../light-dropdowns/common'

interface PricingPanelProps {
  currentLocale: LOCALE
  currentPathname: string
  origin: string
  onNavigate: () => void
}

export const PricingPanel = ({ currentLocale, origin, onNavigate }: PricingPanelProps) => {
  const useGatsbyLink = process.env.GATSBY_PACKAGE_NAME === 'main'
  const mainOrigin = getLocalAppOrigin(origin, 8084)

  const items = [
    {
      key: 'pricing',
      labelKey: 'index.header.pricing.overview',
      to: '/pricing.html',
    },
    {
      key: 'new-user-bonus',
      labelKey: 'index.header.pricing.bonus',
      to: '/new-user-bonus.html',
    },
    {
      key: 'cost-estimator',
      labelKey: 'index.header.pricing.estimator',
      to: '/pricing.html#costestimator',
    },
    {
      key: 'diwali-offer',
      label: 'India Diwali Offer',
      to: '/diwali-special-offer.html',
    },
  ]
  const visibleItems = items.filter((item) => item.key !== 'diwali-offer')

  return (
    <>
      {visibleItems.map((item) => {
        const isAnchorLink = item.to.includes('#')
        const localizedTo = withLocale(item.to, currentLocale)

        return (
          <MainLink
            key={item.key}
            to={localizedTo}
            href={`${mainOrigin}${localizedTo}`}
            useGatsbyLink={useGatsbyLink && !isAnchorLink}
            locale={currentLocale}
            onClick={onNavigate}
          >
            {'label' in item ? item.label : intl.get(item.labelKey)}
          </MainLink>
        )
      })}
    </>
  )
}
